// Copyright (c) Docugami, Inc. All rights reserved.

import { INotificationDescriptor, INotificationProvider, NotificationProviderType } from "notifications/INotificationProvider";
import { useCallback, useEffect, useState } from "react";
import { InteractionStates, NotificationCategory } from "networking/NotificationsApi";
import { FileUploadNotification } from "components/notifications/FileUploadNotification";
import { useUploadProgress } from "./UploadProgress";
const { v4: uuidv4 } = require('uuid');

export const useClientNotificationProvider = (): INotificationProvider => {
    const [descriptors, setDescriptors] = useState<INotificationDescriptor[]>([]);
    const { isUploading } = useUploadProgress();

    const createComponent = useCallback((descriptor: INotificationDescriptor) => {
        if (descriptor.providerType !== NotificationProviderType.Client) {
            throw new Error(`Client notification provider is incompatible with provider type ${descriptor.providerType}.`);
        }

        return <FileUploadNotification startTime={descriptor.timestamp} />
    }, []);

    useEffect(() => {
        if (!isUploading) {
            setDescriptors([]);
        }
        else if (descriptors.length === 0) {
            const descriptor: INotificationDescriptor = {
                providerType: NotificationProviderType.Client,
                id: uuidv4(),
                timestamp: new Date(),
                category: NotificationCategory.Documents,
                interactions: InteractionStates.None
            };

            setDescriptors([descriptor]);
        }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isUploading]);

    return {
        descriptors: descriptors,
        createComponent: createComponent
    };
}
